/**
 * DUNAMIS WEAR — Collection gender tabs (Produtos)
 */
(function () {
  'use strict';

  document.querySelectorAll('.collection-gender-tabs').forEach(function (tablist) {
    var section = tablist.closest('.collection-page--gender');
    if (!section) return;

    var tabs = tablist.querySelectorAll('[data-collection-gender-tab]');
    var panels = section.querySelectorAll('[data-collection-gender-panel]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-collection-gender-tab');

        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var active = panel.getAttribute('data-collection-gender-panel') === target;
          panel.classList.toggle('is-active', active);
          if (active) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      });
    });
  });
})();
